import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import fetchBatchPricesOperation from 'store/price/operation/fetchBatchPricesOperation';
import fetchSearchResultsOperation from './fetchSearchResultsOperation';

const fetchSearchResultsAndPricesOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    await dispatch(fetchSearchResultsOperation()).then(() => {
      dispatch(fetchBatchPricesOperation());
    });
  };

export default fetchSearchResultsAndPricesOperation;
